import React from 'react'
// import FaqsTop
import FaqsTop from './FaqsTop'

const FaqsArea = () => {

  return (
    <>
    <FaqsTop/>

    <section id="faqs_arae_main" className="section_padding_bottom">
        <div className="container">
            <div className="row">
                <div className="col-lg-6">
                    <div className="faqs_area">
                        <div className="accordion" id="accordionExample">
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingOne">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        Mauris blandit aliquet elit
                                    </button>
                                </h2>
                                <div id="collapseOne" className="accordion-collapse collapse show"
                                    aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        <p>
                                            Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a. Quisque velit
                                            nisi, pretium ut lacinia in, elementum id enim. Pellentesque in ipsum id
                                            orci porta dapibus.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingTwo">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                        lacinia in, elementum id enim
                                    </button>
                                </h2>
                                <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo"
                                    data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        <p>
                                            Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a. Quisque velit
                                            nisi, pretium ut lacinia in, elementum id enim. Pellentesque in ipsum id
                                            orci porta dapibus.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingThree">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseThree" aria-expanded="false"
                                        aria-controls="collapseThree">
                                        id orci porta dapibus
                                    </button>
                                </h2>
                                <div id="collapseThree" className="accordion-collapse collapse"
                                    aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        <p>
                                            Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a. Quisque velit
                                            nisi, pretium ut lacinia in, elementum id enim. Pellentesque in ipsum id
                                            orci porta dapibus.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingFour">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseFour" aria-expanded="false"
                                        aria-controls="collapseThree">
                                        Nulla porttitor accumsan tincidunt
                                    </button>
                                </h2>
                                <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour"
                                    data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        <p>
                                            Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a. Quisque velit
                                            nisi, pretium ut lacinia in, elementum id enim. Pellentesque in ipsum id
                                            orci porta dapibus.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="faqs_area">
                        <div className="accordion" id="accordionExample2">
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingOneright">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseOneright" aria-expanded="true">
                                        Mauris blandit aliquet elit
                                    </button>
                                </h2>
                                <div id="collapseOneright" className="accordion-collapse collapse show"
                                    aria-labelledby="headingOneright" data-bs-parent="#accordionExample2">
                                    <div className="accordion-body">
                                        <p>
                                            Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a. Quisque velit
                                            nisi, pretium ut lacinia in, elementum id enim. Pellentesque in ipsum id
                                            orci porta dapibus.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingTworight">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseTworight" aria-expanded="false"
                                        aria-controls="collapseTworight">
                                        lacinia in, elementum id enim
                                    </button>
                                </h2>
                                <div id="collapseTworight" className="accordion-collapse collapse"
                                    aria-labelledby="headingTworight" data-bs-parent="#accordionExample2">
                                    <div className="accordion-body">
                                        <p>
                                            Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a. Quisque velit
                                            nisi, pretium ut lacinia in, elementum id enim. Pellentesque in ipsum id
                                            orci porta dapibus.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingThreeright">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseThreeright" aria-expanded="false"
                                        aria-controls="collapseThreeright">
                                        id orci porta dapibus
                                    </button>
                                </h2>
                                <div id="collapseThreeright" className="accordion-collapse collapse"
                                    aria-labelledby="headingThreeright" data-bs-parent="#accordionExample2">
                                    <div className="accordion-body">
                                        <p>
                                            Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a. Quisque velit
                                            nisi, pretium ut lacinia in, elementum id enim. Pellentesque in ipsum id
                                            orci porta dapibus.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingFourright">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseFourright" aria-expanded="false"
                                        aria-controls="collapseThreeright">
                                        Nulla porttitor accumsan tincidunt
                                    </button>
                                </h2>
                                <div id="collapseFourright" className="accordion-collapse collapse"
                                    aria-labelledby="headingFourright" data-bs-parent="#accordionExample2">
                                    <div className="accordion-body">
                                        <p>
                                            Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a. Quisque velit
                                            nisi, pretium ut lacinia in, elementum id enim. Pellentesque in ipsum id
                                            orci porta dapibus.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}

export default FaqsArea